import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "LimitSection",
    "restrictCheckbox"
  ]

  connect() {
  }

  toggle(){
    if (this.restrictCheckboxTarget.checked) {
      this.LimitSectionTarget.classList.remove("d-none");
    } else {
      this.LimitSectionTarget.classList.add("d-none");
    }
  }
}
